export enum ReminderFrequency {
    one_Day_Before = "1 day before",
    three_Days_Before = "3 days before",
    one_Week_before = "1 week before",
    fifteen_Day_Before = "15 day before",
    none = "none"
}

// Map reminder frequency to days to subtract
export const frequencyDaysMap: Record<ReminderFrequency, number> = {
    [ReminderFrequency.one_Day_Before]: -1,
    [ReminderFrequency.one_Week_before]: -7,
    [ReminderFrequency.three_Days_Before]: -3,
    [ReminderFrequency.fifteen_Day_Before]: -15,
    [ReminderFrequency.none]: 0
};